import makeStyles from "@mui/styles/makeStyles";

import { ListItemCellProps } from "./ListItemCell.types";

export const useStyles = makeStyles((theme) => ({
  root: (props: ListItemCellProps) => ({
    display: "inline-block",
    width: "100%",
    borderRight: props.borderRight
      ? `1px solid ${theme.palette.grey[300]}`
      : "none",

    maxWidth: "99%",
    height: "100%",
    "& .MuiGrid-item": {
      overflow: "hidden !important",
    },
  }),
  chip: {
    verticalAlign: "bottom",
  },
  withChip: {
    display: "inline-grid",
  },
  withoutChip: {
    display: "block",
  },
}));
